(function() {
    'use strict';

    angular.module('remitEventsApp').config(function($urlRouterProvider) {
        function changeLangugage($cookies, $rootScope, $translate, $state, moment, tmhDynamicLocale, language) {
            moment.locale(language);
            tmhDynamicLocale.set(language);

            $cookies.putObject('remit-lang', language);

            $translate.use(language).then(function() {
                $rootScope.$broadcast('languageChange', language);

                $state.transitionTo('main', _.extend({}, $state.params, { lang: language }), {
                    reload: true,
                    inherit: false,
                    notify: true
                });
            });
        }

        $urlRouterProvider.otherwise('/');
        $urlRouterProvider.when('/en', '/Remit/EN');
        $urlRouterProvider.when('/pl', '/Remit/PL');
        $urlRouterProvider.when('/Remit/PL', [
            '$cookies',
            '$rootScope',
            '$translate',
            '$state',
            'moment',
            'tmhDynamicLocale',
            function($cookies, $rootScope, $translate, $state, moment, tmhDynamicLocale) {
                changeLangugage($cookies, $rootScope, $translate, $state, moment, tmhDynamicLocale, 'pl');
            }
        ]);
        $urlRouterProvider.when('/Remit/EN', [
            '$cookies',
            '$rootScope',
            '$translate',
            '$state',
            'moment',
            'tmhDynamicLocale',
            function($cookies, $rootScope, $translate, $state, moment, tmhDynamicLocale) {
                changeLangugage($cookies, $rootScope, $translate, $state, moment, tmhDynamicLocale, 'en');
            }
        ]);
    });
})();
